(function ($) {
  Drupal.behaviors.simpleDropdown = {
    attach: function (context) {
      $('.simple_dropdown__drawer', context).hide();

      $('.js-simple_dropdown .simple_dropdown__cta', context).on('click', function (e) {
        e.stopPropagation();
        var drop = $(this).siblings('.simple_dropdown__drawer');

        if (drop.is(':hidden')) {
          $('.open').toggleClass('open')
            .siblings('.simple_dropdown__drawer').hide();
          drop.show();
          $(this).toggleClass('open');
        } else {
          $('.simple_dropdown__drawer', context).hide();
        }
      });

      $('.js-simple_dropdown .simple_dropdown__close', context).on('click', function (e) {
        e.stopPropagation();
        var dropOpen = $(this).parent('.simple_dropdown__drawer');

        if (dropOpen.is(':visible')) {
          $('.simple_dropdown__drawer', context).hide();
        }
      });
    }
  };
})(jQuery);
